<template>
    <section id=contact class=min-height-full>
      <article>
        <h1>Contact</h1>
        <h2>Booking & Licensing</h2>
        <p>eightbittiger@gmail.com</p>
        <h2>Social</h2>
        <div class=contact-social><a target=_blank href="https://www.facebook.com/Eight-Bit-Tiger-112557322147662/"><i
              class=fi-social-facebook></i></a><a target=_blank href=https://twitter.com/eightbittiger> <i
            class=fi-social-twitter></i></a><a target=_blank href="https://instagram.com/eightbittiger/"><i
              class=fi-social-instagram></i></a><a target=_blank
            href="https://play.spotify.com/artist/1ywZMLc9BKOYF0N2VxnANF?play=true&amp;utm_source=open.spotify.com&amp;utm_medium=open"><i
              class=fi-social-spotify></i></a></div>
      </article>
    </section>
</template>

<script>
export default {
    name:"Contact",
}
</script>